<h1 mat-dialog-title>Contact</h1>
<mat-dialog-content>
  <p class="support-contact-dialog__line">
    <span class="support-contact-dialog__label">Email:</span>
    <a [href]="emailHref">{{ email }}</a>
  </p>
  <p class="support-contact-dialog__line">
    <span class="support-contact-dialog__label">Phone:</span>
    <a [href]="phoneHref">{{ phone }}</a>
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
